import { memo } from "react";

function InterviewStructureSkeleton() {
  return (
    <div className="w-[90%] ml-5 my-6 space-y-4 animate-pulse">
      {/* Heading */}
      <div className="space-y-2">
        <div className="w-48 h-5 bg-gray-200 rounded" />
        <div className="w-64 h-3 bg-gray-200 rounded" />
      </div>

      {/* Accordion Skeleton */}
      {Array.from({ length: 3 }).map((_, stageIdx) => (
        <div
          key={stageIdx}
          className="px-3 py-4 bg-white border rounded-lg space-y-4"
        >
          {/* Accordion Header */}
          <div className="flex items-center justify-between">
            <div className="w-40 h-4 bg-gray-200 rounded" />
            <div className="w-12 h-5 bg-gray-200 rounded" />
          </div>

          {/* Expanded Content */}
          <div className="space-y-3">
            {/* Description */}
            <div className="w-full h-3 bg-gray-200 rounded" />
            <div className="w-[85%] h-3 bg-gray-200 rounded" />

            {/* Topics */}
            <div className="space-y-2">
              <div className="w-24 h-4 bg-gray-200 rounded" />
              {Array.from({ length: 3 }).map((_, idx) => (
                <div
                  key={idx}
                  className="w-[70%] h-3 bg-gray-200 rounded ml-4"
                />
              ))}
            </div>

            {/* Questions */}
            <div className="space-y-2">
              <div className="w-32 h-4 bg-gray-200 rounded" />
              {Array.from({ length: 2 }).map((_, idx) => (
                <div key={idx} className="flex gap-2 items-start">
                  <div className="w-6 h-5 bg-gray-200 rounded" />
                  <div className="w-full h-3 bg-gray-200 rounded" />
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default memo(InterviewStructureSkeleton);
